import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const InfoShape = ({
  width = 20,
  height = 20,
  fillColor = '#000',
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="12" cy="12" r="10" stroke={fillColor} strokeWidth="1.5" />
      <path
        d="M12 17V11"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="1"
        cy="1"
        r="1"
        transform="matrix(1 0 0 -1 11 9)"
        fill={fillColor}
      />
    </svg>
  );
};

export default InfoShape;
